<template>
  <div id="recognitionContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_power-ups.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.recognition") }}</span>
        <div class="page-des-line">
          <span class="page-des ml-10">{{
            $t("page.recognition_description")
          }}</span>
        </div>
      </div>
      <el-tabs
        class="style-bar"
        v-bind:value="activeName"
        @tab-click="forceRerender"
      >
        <el-tab-pane label="Create" name="create" default v-if="user.user_type !== 'leadership'">
          <span slot="label" class="title-bar">{{ $t("page.create") }}</span>
          <create
            v-if="renderComponent == false && activeName == 'create'"
          ></create>
        </el-tab-pane>
        <el-tab-pane label="Outbox" name="outbox" v-if="user.user_type !== 'leadership'">
          <span slot="label" class="title-bar">{{ $t("page.outbox") }}</span>
          <outbox
            v-if="renderComponent == false && activeName == 'outbox'"
          ></outbox>
        </el-tab-pane>
        <el-tab-pane label="Activity" name="activity">
          <span slot="label" class="title-bar">{{ $t("page.activity") }}</span>
          <activity
            v-if="renderComponent == false && activeName == 'activity'"
          ></activity>
        </el-tab-pane>
        <el-tab-pane label="Leaderboards" name="leaderboards">
          <span slot="label" class="title-bar">{{ $t("page.leaderboards") }}</span>
          <leaderboards
            v-if="renderComponent == false && activeName == 'leaderboards'"
          ></leaderboards>
        </el-tab-pane>
        <el-tab-pane v-if="this.companyData && this.companyData.show_integration && this.companyData.show_integration == 'Y' && user.user_type !== 'leadership'" label="Activity" name="integrations">
          <span slot="label" class="title-bar">{{
            $t("page.integrations")
          }}</span>
          <integrations
            v-if="renderComponent == false && activeName == 'integrations'"
          ></integrations>
        </el-tab-pane>
      </el-tabs>
      <component
        v-if="
          (activeName == 'create' ||
            activeName == 'outbox' ||
            activeName == 'activity' ||
            activeName == 'integrations'||
            activeName == 'leaderboards') &&
          renderComponent
        "
        v-bind:is="activeName"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: "recognition",
  created() {
    this.$store.dispatch("powerups/getActiveTabs");
  },
  components: {
    create: require("./powerups/create").default,
    outbox: require("./powerups/outbox").default,
    activity: require("./powerups/activity").default,
    leaderboards: require("./powerups/leaderboards").default,
    integrations: require("./powerups/integrations").default,
  },
  data() {
    return {
      anchor: {
        create: "create",
        outbox: "outbox",
        activity: "activity",
        integrations: "integrations",
        leaderboards: "leaderboards",
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    companyData() {
      return this.$store.getters["authen/companyData"];
    },
    activeName() {
      return this.$store.getters["powerups/activeName"];
    },
    isLeadershipUser() {
      return this.user && this.user.user_type === "leadership";
    },
    renderComponent() {
      return this.$store.getters["powerups/renderComponent"];
    },
  },
  mounted() {
    let params = this.$router.currentRoute.params.tab;
    
    if(this.isLeadershipUser){
      params = this.canAccessTab(params) ? params : 'activity'
        this.$store.commit("powerups/setActiveTabs", {
          activeName: params,
          renderComponent: false,
        });
    }else if (params && this.anchor[params]) {
        this.$store.commit("powerups/setActiveTabs", {
          activeName: params,
          renderComponent: false,
        });
        
    }else {
      this.$router.push({ name: "recognition", params: { tab: "create" } });
    }
    this.rootChangeTabHandler = (item) => {
      if (item.path == "recognition") {
        item.name = item.tab;
        this.forceRerender(item);
      }
    };
    this.$root.$on('changeTab', this.rootChangeTabHandler);
  },
  beforeDestroy() {
    if (this.rootChangeTabHandler) {
      this.$root.$off('changeTab', this.rootChangeTabHandler);
    }
  },
  methods: {
    canAccessTab(tab) {
      if (!tab) return false;
      if (!this.isLeadershipUser) {
        return !!this.anchor[tab];
      }
      return tab === "activity" || tab === "leaderboards";
    },
    forceRerender(obj) {
      if (!this.canAccessTab(obj.name)) {
        obj.name = this.isLeadershipUser ? "activity" : "create";
      }
      if (this.renderComponent == true) {
        this.$store.commit("powerups/setActiveTabs", {
          activeName: obj.name,
          renderComponent: false,
        });
      } else {
        this.$store.commit("powerups/setActiveTabs", {
          activeName: obj.name,
          renderComponent: true,
        });
      }
      this.$router.push({ name: "recognition", params: { tab: obj.name } });
    },
  },
};
</script>

<style>
#recognitionContainer {
  font-family: Lato, 'Kanit', Arial, sans-serif;
}
#recognitionContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#recognitionContainer .el-tabs__header {
  margin: 0px;
}
</style>
